export class ForgeProjectFeaturePreview {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.thumbnail = model.thumbnail;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
        this.isPublished = model.isPublished;
        this.isArchived = model.isArchived;
    }
    toRemote() {
        return {
            ...this,
            createdAt: this.createdAt.toISOString(),
            updatedAt: this.updatedAt.toISOString(),
        };
    }
}
